import installAlias from './alias';
import installFilters from './filters';
import installModal from './modal';
import installNotify from './notify';
import installMessage from './message';
import installStorage from './storage';
import installStyle from './style';
import installUtil from './util';
import installHttp from './http';
import installBus from './bus';
import installImageUtil from './imageUtil';
import installIndexedDb from './indexedDB';

export default {
    installAlias,
    installFilters,
    installModal,
    installNotify,
    installStorage,
    installMessage,
    installStyle,
    installUtil,
    installHttp,
    installBus,
    installImageUtil,
    installIndexedDb
};










